import { Routes } from '@angular/router';

import { authGuard } from './shared';
import { AuthCallbackComponent } from './shared';
import { LoginComponent } from './login';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./layout/layout.routes').then((m) => m.routes),
    canActivate: [authGuard],
  },
  { path: 'auth-callback', component: AuthCallbackComponent },
  { path: 'login', component: LoginComponent },
  {
    path: 'not-found',
    loadChildren: () => import('./not-found/not-found.routes').then((m) => m.routes),
  },
  { path: '**', redirectTo: 'not-found' },
];
